/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';

import {InspectorControls} from '@wordpress/block-editor';
/**
* Internal dependencies
*/
import {VayuBlocksHeaderTab,usePanelSettings} from '@vayu-blocks';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import QuerySettingPanel from './settings/index.js';
import {
    Fragment,
    useState
} from '@wordpress/element';

const panelKeys = [
    'vb-loop-set',
    'vb-loop-filter',
];

const initialPanels = {
    setting: 'vb-loop-set',
    advanced: '',
};

const panelOptions = [
    { label: __( 'Setting', 'vayu-blocks' ), value: 'setting', icon: 'colorwand'},
    { label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const InsSettings = (props) => {

    const {
		attributes,
		setAttributes,
		clientId
	} = props;
    
   const {tab, setTab, openPanels, onTogglePanel  } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'setting' });
   const tabComponents = {
			setting: <QuerySettingPanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
			advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} exclude={['displayConditions']} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};
   return (
   <Fragment>
       <InspectorControls>
           <div className='th-block-ins'>
           <VayuBlocksHeaderTab 
                                value={ tab }
                                options={panelOptions}
                                onChange={ setTab }
                            />
                        
                        {tabComponents[tab]}
    </div>
    </InspectorControls>
    </Fragment>
   );
};
export default InsSettings;